<template>
  <div>
    <div class="d-flex justify-content-center w-100">
      <div class="w-100">
        <form @submit.prevent="handleSave">
          <div class="row" style="margin-bottom: 10px">
            <div class="col-6">
              <div class="thesisLabels">
                Fund Name
                <span class="required">*</span>
              </div>
              <vue-bootstrap-typeahead
                :data="fundsList"
                v-model="fundName"
                ref="refFundName"
                class="diligenceAutoCompleteClass"
                :serializer="checkFund"
                :minMatchingChars="minMatchingChars"
                placeholder="Enter Fund Name"
                @keypress="validations"
                @hit="onAfterFundSelection"
              >
                <template slot="suggestion" slot-scope="{ data }">
                  <div
                    :class="
                      data && data.duplicate == 'found' ? 'duplicate' : ''
                    "
                  >
                    <div
                      class="dd-icon-wrapper"
                      v-if="
                        data.properties && data.properties.profile_image_url
                      "
                    >
                      <img
                        class="dd-icon"
                        height="30"
                        width="30"
                        :src="getImageUrl(data.properties.profile_image_url)"
                      />
                    </div>
                    {{ data.properties.name }}
                    <span class="gray">{{
                      data.properties.short_description
                    }}</span>
                    <span
                      v-if="data && data.duplicate == 'found'"
                      class="exists"
                      >already exists</span
                    >
                  </div>
                </template>
              </vue-bootstrap-typeahead>
            </div>
            <div class="col-6">
              <div class="thesisLabels">
                Workspace Name <span class="required">*</span>
              </div>
              <input
                type="text"
                placeholder="Workspace Name"
                class="form-control"
                v-model="workspaceName"
                @keyup="validations"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="thesisLabels">
                Fund Size
                <span class="required">*</span>
              </div>
              <input
                type="number"
                placeholder="Fund Size"
                class="form-control"
                min="0"
                v-model="thesisData.size"
                @keyup="validations"
              />
            </div>
            <div class="col-6">
              <div class="thesisLabels" style="/*margin-bottom: 5px*/">
                Status
                <span class="required">*</span>
              </div>
              <v-select
                :options="vals.statusDropdown"
                class="form-control thesis-form-select"
                v-model="thesisData.status"
                @change="validations"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="thesisLabels">
                GP Ownership %
                <span class="required">*</span>
              </div>
              <input
                type="number"
                placeholder="GP Ownership %"
                class="form-control"
                max="100"
                v-model="thesisData.gpOwnership"
                @keyup="validations"
              />
            </div>

            <div class="col-6">
              <div class="thesisLabels">
                Carry %
                <span class="required">*</span>
              </div>
              <input
                type="number"
                placeholder="Carry %"
                class="form-control"
                min="1"
                max="100"
                v-model="thesisData.gpCarryProfit"
                @keyup="validations"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="thesisLabels">Start Date</div>
              <input
                class="todo-form-date todo-form form-control"
                type="date"
                :value="
                  thesisData.startDate &&
                  moment.utc(thesisData.startDate).format('YYYY-MM-DD')
                    ? moment.utc(thesisData.startDate).format('YYYY-MM-DD')
                    : moment.utc(new Date()).format('YYYY-MM-DD')
                "
                @input="
                  thesisData.startDate = moment($event.target.valueAsDate)
                "
              />
            </div>
            <div class="col-6">
              <div class="thesisLabels">End Date</div>
              <input
                class="todo-form-date todo-form form-control"
                type="date"
                :value="
                  thesisData.endDate &&
                  moment.utc(thesisData.endDate).format('YYYY-MM-DD')
                    ? moment.utc(thesisData.endDate).format('YYYY-MM-DD')
                    : moment.utc(new Date()).format('YYYY-MM-DD')
                "
                @input="thesisData.endDate = moment($event.target.valueAsDate)"
              />
            </div>
          </div>
          <div class="row" style="display: none">
            <div class="col-6">
              <div class="thesisLabels">Start Date</div>
              <input
                type="date"
                placeholder="Fund Location"
                class="form-control"
                v-model="thesisData.startDate"
              />
            </div>
            <div class="col-6">
              <div class="thesisLabels">End Date</div>
              <input
                type="date"
                placeholder="Fund Location"
                class="form-control"
                v-model="thesisData.endDate"
              />
            </div>
          </div>
          <div class="row" style="margin-bottom: 10px">
            <div class="col-6">
              <div class="thesisLabels" style="/*margin-bottom: 5px*/">
                Stage
              </div>
              <v-select
                class="form-control thesis-form-select"
                :options="vals.stageDropdown"
                v-model="investor_stage"
                @input="
                  validations;
                  investor_stage_check = true;
                "
              ></v-select>
            </div>
            <div class="col-3">
              <div class="thesisLabels">Vintage</div>
              <input
                type="text"
                placeholder="Vintage"
                class="form-control"
                v-model="thesisData.vintage"
              />
            </div>
            <div class="col-3 pl-0">
              <div class="thesisLabels">Fund Term</div>
              <input
                type="number"
                placeholder="Fund Term"
                class="form-control"
                v-model="thesisData.term"
              />
            </div>
          </div>
          <!-- <div class="row">
          <div class="col-6">
            <div class="thesisLabels" style="margin-bottom: 4px">Sector</div>
            <multiselect
              v-model="sectorValues"
              :options="availableSectors"
              :multiple="true"
              :custom-label="customLabel"
              placeholder="Sectors"
              class="filtersMultiselectDropdown sectorStatusMultiselectDropdown"
            ></multiselect>
          </div>
          <div class="col-6">
            <div class="thesisLabels" style="margin-bottom: 4px">Stage</div>
            <multiselect
              v-model="stageValues"
              :options="availableStages"
              :multiple="true"
              :custom-label="customLabel"
              placeholder="Stages"
              class="filtersMultiselectDropdown sectorStatusMultiselectDropdown"
            ></multiselect>
          </div>
        </div> -->
          <!-- <div class="row">
          <div class="col-12">
            <div class="thesisLabels" style="margin-top: 10px">
              Investment Check Size
            </div>
            <div style="margin-bottom: 10px">
              <ejs-slider
                id="default"
                :min="min"
                :max="max"
                :step="step"
                :ticks="ticks"
                :tooltip="tooltip"
                :mintyp="mintype"
                :type="type"
                :value="value"
                cssClass="createWorkspaceSlider"
                :renderingTicks="renderingTicks"
                :tooltipChange="tooltipChange"
                :change="sizeChange"
              ></ejs-slider>
            </div>
          </div>
        </div> -->
          <!-- <div class="row" style="margin-top: 10px">
          <div class="col-6">
            <div class="thesisLabels">Fund Location</div>
            <input
              type="text"
              placeholder="Fund Location"
              class="form-control"
              v-model="thesisData.location"
            />
          </div>
          <div class="col-6">
            <div class="thesisLabels">Investment Geography</div>
            <input
              type="text"
              placeholder="Investment Geography"
              class="form-control"
              v-model="thesisData.geography"
            />
          </div>
        </div> -->
          <div class="row">
            <div class="col-12">
              <div class="thesisLabels">What sets this fund apart</div>
              <textarea
                placeholder="This is where you add your fund’s strategic differentiator including your insights into the sectors or market opportunity based on your experience or your “special sauce”. This area needs to show why you are uniquely qualified to execute on this fund, and how you are creating proprietary deal flow with your fund. For example: East Coast fin-tech startups from my 15 years of experience working in the financial and banking areas within the San Francisco bay area."
                rows="5"
                cols="50"
                class="form-control"
                v-model="thesisData.secretSauce"
              ></textarea>
            </div>
          </div>
          <div v-if="showAdditionalInfo">
            <div class="row">
              <div class="col-12">
                <div class="lpAdditionalInfoCls">Additional information</div>
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-6">
                <div class="thesisLabels">Fund Size</div>
                <input
                  type="number"
                  placeholder="Fund Companies"
                  class="form-control"
                  @change="fundChanged = true"
                  v-model="fundAdditionalData.fund_size"
                />
              </div> -->
              <div class="col-12">
                <div class="thesisLabels">No. of Companies</div>
                <input
                  type="number"
                  placeholder="No. of Companies"
                  class="form-control"
                  @change="fundChanged = true"
                  v-model="fundAdditionalData.fund_no_of_companies"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="thesisLabels">Exits</div>
                <input
                  type="number"
                  placeholder="Exits"
                  class="form-control"
                  @change="fundChanged = true"
                  v-model="fundAdditionalData.fund_exits"
                />
              </div>
              <div class="col-6">
                <div class="thesisLabels">Value Of Portfolio</div>
                <input
                  type="number"
                  placeholder="Value Of Portfolio"
                  class="form-control"
                  @change="fundChanged = true"
                  v-model="fundAdditionalData.fund_value_of_portfolio"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="thesisLabels">MOIC</div>
                <input
                  type="number"
                  placeholder="MOIC"
                  step=".01"
                  class="form-control"
                  @change="fundChanged = true"
                  v-model="fundAdditionalData.fund_moic"
                />
              </div>
              <div class="col-6">
                <div class="thesisLabels">TVPI</div>
                <input
                  type="number"
                  placeholder="TVPI"
                  step=".01"
                  class="form-control"
                  @change="fundChanged = true"
                  v-model="fundAdditionalData.fund_tvpi"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="thesisLabels">DPI</div>
                <input
                  type="number"
                  placeholder="DPI"
                  class="form-control"
                  step=".01"
                  @change="fundChanged = true"
                  v-model="fundAdditionalData.fund_dpi"
                />
              </div>
              <div class="col-6">
                <div class="thesisLabels">IRR</div>
                <input
                  type="number"
                  placeholder="IRR"
                  class="form-control"
                  step=".01"
                  max="100"
                  @change="fundChanged = true"
                  v-model="fundAdditionalData.fund_irr"
                />
              </div>
            </div>
          </div>
          <div class="col-12 d-flex" style="padding: 0px">
            <div
              class="col-xl edit-company-action-button-row"
              style="padding: 0px; margin-bottom: 30px"
            >
              <button
                type="button"
                class="todo-form-cancel-button btn-outline-secondary"
                @click="handleCancel"
              >
                Cancel
              </button>
              <button
                type="button"
                @click.prevent="showAdditionalInfo = true"
                class="todo-form-submit-button btn btn-primary"
                style="height: 35px; margin-right: 0px"
                :disabled="showSpinner || saveDisable"
                v-if="!showAdditionalInfo"
              >
                Next
              </button>

              <button
                type="submit"
                class="todo-form-submit-button btn btn-primary"
                style="height: 35px; margin-right: 0px"
                :disabled="showSpinner || saveDisable"
                v-else
              >
                Save
                <b-spinner
                  v-if="showSpinner"
                  style="float: right"
                  small
                  label="Loading..."
                ></b-spinner>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlider from "vue-slider-component";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import "vue-slider-component/theme/default.css";
import {
  formatCurrency,
  vals,
  formatNumber,
  formatNumberWithComma,
  precisionNumberForamtter,
  cbAdapter,
} from "../../../util";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import moment from "moment";
import workspace from "../../../store/modules/workspace";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import config from "../../../../config/settings";
const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
import _ from "lodash";
export default {
  name: "LpCreateWorkspace",
  components: {
    VueSlider,
    Multiselect,
    [Select.name]: Select,
    [Option.name]: Option,
    VueBootstrapTypeahead,
  },
  props: {
    workspace: String,
  },
  data() {
    return {
      vals,
      options: ["naveen", "sonu"],
      sectorValues: [],
      stageValues: [],
      value: [500000, 4000000],
      showSpinner: false,
      saveDisable: false,
      thesisData: {},
      thesisRecords: [],
      fundData: {},
      title: "",
      showDocument: true,
      workspaceId: "",
      fundName: "",
      isNewFund: false,
      selected: false,
      fundsList: [],
      portfolioAll: [],
      fund_data: {},
      existingFund: {},
      minMatchingChars: 1,
      showAdditionalInfo: false,
      fundChanged: false,
      fundAdditionalData: {},
      oldfundAdditionalData: {},
      investor_stage: "",
      investor_stage_check: false,
      workspaceName: "",
    };
  },
  computed: {
    ...mapGetters("user", ["currency"]),
    ...mapGetters("workspace", ["workspaces"]),
    buttonText() {
      if (this.title == "Create Thesis") {
      } else {
        return "Save";
      }
    },
    moment() {
      return moment;
    },
    availableSectors() {
      return this.vals.SECTOR_DEFINES.filter(
        (opt) => this.sectorValues.indexOf(opt) === -1
      );
    },
    availableStages() {
      return this.vals.WORKSPACE_STAGES.filter(
        (opt) => this.stageValues.indexOf(opt) === -1
      );
    },
  },
  methods: {
    formatCurrency: formatCurrency,
    precisionNumberForamtter: precisionNumberForamtter,
    insertFundAdditionalData(workspace_id, isCreate) {
      let self = this;
      let payload = JSON.parse(JSON.stringify(self.fundAdditionalData));
      payload.fund_size = self.thesisData.size;
      payload.workspace_id = workspace_id;
      let check = false;
      if (isCreate && this.fundChanged && Object.keys(payload).length > 0) {
        check = true;
      } else if (
        this.fundChanged &&
        !isCreate &&
        JSON.stringify(this.oldfundAdditionalData) != JSON.stringify(payload)
      ) {
        check = true;
      } else {
        return;
      }
      if (check) {
        self.$store
          .dispatch("lpAllocations/apiPostAdditionalFundData", payload)
          .then((data) => {
            this.fundChanged = false;
          })
          .catch((err) => {
            self.$toaster.error("Failed to Insert Fund Data!!!");
          });
      }
    },
    customLabel(option) {
      return `${option}`;
    },
    renderingTicks: function (args) {
      args.text = this.formatCurrency(args.value, this.currency.ref, 0, true);
    },
    tooltipChange: function (args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = formatNumberWithComma(args.value[0]);
        max = formatNumberWithComma(args.value[1]);
        // min = this.formatCurrency(args.value[0], this.currency.ref, 0, true);
        // max = this.formatCurrency(args.value[1], this.currency.ref, 0, true);
      }
      if (min && max) args.text = `$${min} - $${max}`;
    },
    roundNumber(value) {
      if (value <= 10) return (value / 10).toFixed() * 10;
      else if (value > 10 && value <= 999) return (value / 100).toFixed() * 100;
      else if (value >= 1000) return (value / 100).toFixed() * 100;
    },
    sizeChange(args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = args.value[0];
        max = args.value[1];
      }
      if (String(min) && String(max)) {
        this.value = [min, max];
      }
    },
    async getfunds(query) {
      this.isNewFund = false;
      this.selected = false;
      
      let responseData = await api.get(`search?key=${query}`);

      const suggestions = cbAdapter(responseData);

      if (suggestions.data.items && suggestions.data.items.length > 0)
        this.fundsList = suggestions.data.items;
      else {
        this.fundsList = [
          {
            properties: {
              name: this.fundName,
              short_description: "No results Found. Continue..",
            },
          },
        ];
      }
    },
    validations() {
      if (
        this.thesisData &&
        this.thesisData.name &&
        this.thesisData.size &&
        this.thesisData.status &&
        this.thesisData.gpOwnership &&
        this.thesisData.gpCarryProfit &&
        this.workspaceName &&
        this.thesisData.name === this.fundName
      ) {
        this.saveDisable = false;
      } else {
        this.saveDisable = true;
      }
    },
    addGpAndCarry() {
      const self = this;
      let serverData = [];
      let carryObj = {};
      let gpObj = {};
      return new Promise((resolve, reject) => {
        let carryPercentage =
          this.thesisData.gpCarryProfit && Number(this.thesisData.gpCarryProfit)
            ? Number(this.thesisData.gpCarryProfit)
            : 20;
        let ownership =
          this.thesisData.gpOwnership && Number(this.thesisData.gpOwnership)
            ? Number(this.thesisData.gpOwnership)
            : 1;
        carryObj.entity_name = "Carry";
        carryObj.entity_type = "GP Carry";
        carryObj.ownership = 0;
        carryObj.distributions = 0;
        carryObj.profit = Number(carryPercentage);
        carryObj.lp_percentage = 0;
        carryObj.created = new Date();
        carryObj.created_by = this.$route.params.account_id;
        carryObj.workspace = this.workspaceId;
        serverData.push(carryObj);
        gpObj.entity_name = "GP";
        gpObj.entity_type = "GP";
        gpObj.ownership = Number(ownership);
        gpObj.capital_commitment = Number(
          (
            Number(gpObj.ownership / 100) * Number(this.thesisData.size)
          ).toFixed(2)
        );
        gpObj.lp_percentage = 0;
        gpObj.profit = Number(
          (
            1 -
            Number(Number(carryPercentage) / 100) * Number(ownership)
          ).toFixed(2)
        );
        gpObj.capital_called = 0;
        gpObj.contributed_to_date = 0;
        gpObj.open_balance = 0;
        gpObj.remaining_commitment = Number(gpObj.capital_commitment);
        gpObj.distributions = 0;
        gpObj.created = new Date();
        gpObj.created_by = this.$route.params.account_id;
        gpObj.workspace = this.workspaceId;

        serverData.push(gpObj);
        self.$store
          .dispatch("lpAllocations/apiBulkPostDetailsData", serverData)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    handleFundSave(type) {
      let self = this;
      let payload = JSON.parse(JSON.stringify(this.fund_data));
      payload.workspace_id = this.workspaceId
        ? this.workspaceId
        : this.workspace;
      payload.direct = "Direct";
      payload.cost = 0;
      payload.value = 0;
      payload.investor_stage = self.investor_stage;
      payload.data_status = "Unconfirmed";
      if (!payload.permalink && self.isNewFund) {
        payload.properties = {};
        payload.properties.name = this.diligenceName;
        payload.current_stage = "Pre-Seed";
        payload.data_status = "Confirmed";
        payload.status = "Unknown";
      }
      return new Promise((resolve, reject) => {
        if (type == "create") {
          self.$store
            .dispatch("portfolio/_apiPostFundByWorkspace", payload)
            .then((data) => {
              _.assignIn(payload, data.success[0]);
              if (data.success && data.success.length > 0) {
                this.confirmCompany(payload);
              }
              resolve(data);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          if (self.existingFund && self.existingFund.name == payload.name) {
            resolve();
          } else {
            let companies = self.portfolioAll;
            let check = companies.find(
              (item) => item.name.toLowerCase() == payload.name.toLowerCase()
            );
            if (check) {
              reject({ message: "Fund already exits." });
            } else {
              let portfolio = self.portfolioAll.find(
                (item) =>
                  item.user_investment_status &&
                  item.user_investment_status.toLowerCase() == "fund"
              );
              self.$store
                .dispatch("offering/apiDeletePortfolioOfferingsByWorkspace", {
                  ucid: portfolio.ucid,
                  workspace_id: payload.workspace_id,
                })
                .then((res) => {
                  return self.$store.dispatch(
                    "people/_apiDeletePeopleByWorkspace",
                    {
                      ucid: portfolio.ucid,
                      workspace_id: payload.workspace_id,
                    }
                  );
                })
                .then((res) => {
                  return self.$store.dispatch(
                    "portfolio/apiDeletePortfolioByWorkspace",
                    {
                      ucid: portfolio.ucid,
                      workspace_id: payload.workspace_id,
                    }
                  );
                })
                .then((res) => {
                  return self.$store.dispatch(
                    "portfolio/_apiPostFundByWorkspace",
                    payload
                  );
                })
                .then((res) => {
                  if (res.success && res.success.length > 0) {
                    this.confirmCompany(res.success[0]);
                  }
                  return self.$store.dispatch("contacts/start");
                })
                .then((data) => {
                  self.getWorkspacePortfolio();
                  resolve(data);
                });
            }
          }
        }
      });
    },
    confirmCompany(data) {
      let workspace_id = this.workspaceId ? this.workspaceId : this.workspace;
      let portfolio = {
        company: data._id,
        org_company_id: data._id,
      };
      if (!data || data.data_status == DATA_STATUS_UNCONFIRMED) {
        let url = `${this.$route.params.account_id}/${workspace_id}/company/confirm`;

        api
          .post(url, {
            encrypt: {
              data: {
                company: portfolio,
                confirmedCompany: data.cb_data ? data.cb_data : {},
              },
            },
          })
          .catch((err) => {
            console.log("Fail to confirm fund", { err });
          });
      }
    },
    changeFundStage() {
      let self = this;
      if (
        self.existingFund &&
        self.existingFund.investor_stage != self.investor_stage
      ) {
        let payload = {
          workspace_id: self.existingFund.workspace,
          _id: self.existingFund._id,
          investor_stage: self.investor_stage,
        };
        self.$store
          .dispatch("company/apiPatchCompanyInstByWorkspace", payload)
          .then((data) => {
            let fiifi = JSON.parse(localStorage.fiifi).user;
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
              if (payload.workspace_id == fiifi.workspace_id) {
                self.existingFund.investor_stage = self.investor_stage;
                self.investor_stage_check = false;
                self.$store.dispatch("portfolio/_apiFetchPortfolio");
              }
            }
          })
          .catch((err) => {
            console.log("Fail to update fund", { err });
          });
      }
    },
    handleSave() {
      const self = this;
      this.showSpinner = true;
      let serverData = JSON.parse(JSON.stringify(this.thesisData));
      this.fund_data.fund_status = serverData.status ? serverData.status : "";
      serverData.size = Number(serverData.size);
      serverData.sectors = this.sectorValues;
      serverData.stages = this.stageValues;
      serverData.checkSizeMin =
        this.value.length >= 1 && this.value[0]
          ? this.roundNumber(this.value[0])
          : "";
      serverData.checkSizeMax =
        this.value.length >= 1 && this.value[1]
          ? this.roundNumber(this.value[1])
          : "";
      serverData.gpOwnership = Number(serverData.gpOwnership)
        ? Number(serverData.gpOwnership)
        : 0;
      serverData.gpCarryProfit = Number(serverData.gpCarryProfit)
        ? Number(serverData.gpCarryProfit)
        : 0;
      serverData.term = Number(serverData.term) ? Number(serverData.term) : 0;
      if (this.title == "Create Thesis") {
        this.handleCreateWorkspace()
          .then((workspaceData) => {
            api
              .post(
                `/${this.$route.params.account_id}/${this.workspaceId}/thesis`,
                {
                  encrypt: {
                    data: serverData,
                  },
                }
              )
              .then((data) => {
                this.insertFundAdditionalData(this.workspaceId, true);
                this.handleFundSave("create")
                  .then((fundResp) => {
                    this.addGpAndCarry()
                      .then((response) => {
                        this.getThesisData();
                        this.$toaster.success("Saved Successfully.");
                      })
                      .catch((error) => {
                        self.showSpinner = false;
                        this.$toaster.error("Failed to Insert!!!");
                        console.log("error in insering in gp and carry", error);
                      });
                  })
                  .catch((err) => {
                    self.showSpinner = false;
                    this.$toaster.error("Failed to Insert!!!");
                    console.log(
                      "error in insering in fund additonal data",
                      err
                    );
                  });
              })
              .catch((error) => {
                self.showSpinner = false;
                this.$toaster.error("Failed to Insert!!!");
                console.log("error in insering in thesis", error);
              });
          })
          .catch((error) => {
            this.$toaster.error("Failed to create Workspace");
            self.showSpinner = false;
            console.log("error in creating workspace", error);
          });
      } else {
        if (serverData._id) {
          this.handleFundSave("edit")
            .then((fundResp) => {
              if (this.investor_stage_check) this.changeFundStage();
              this.handleEditWorkspace()
                .then((editWorkspace) => {
                  api
                    .patch(
                      `/${this.$route.params.account_id}/${serverData._id}/thesis`,
                      {
                        encrypt: {
                          data: serverData,
                        },
                      }
                    )
                    .then((data) => {
                      this.insertFundAdditionalData(this.workspace, false);
                      this.editGpAndCarry()
                        .then((response) => {
                          this.updateLpDetails()
                            .then((updateResponse) => {
                              self
                                .updateDistributionCallData()
                                .then((updateDistributionsData) => {
                                  self
                                    .updateDetailsDataDistributions()
                                    .then((updateDetailDistributionData) => {
                                      self
                                        .updateCurrentCapitalCallData()
                                        .then((updateCurrenCapitalCallData) => {
                                          self
                                            .updateSummaryData()
                                            .then((updateSummaryData) => {
                                              this.getThesisData();
                                              this.$toaster.success(
                                                "Saved Successfully."
                                              );
                                              self.showSpinner = false;
                                              self.$router.go(-1);
                                            });
                                        })
                                        .catch((error) => {
                                          self.showSpinner = false;
                                          this.$toaster.error(
                                            "Failed to update!!!"
                                          );
                                          console.log(
                                            "error in updateCurrentCapitalCallData in lp details",
                                            error
                                          );
                                        });
                                    })
                                    .catch((error) => {
                                      self.showSpinner = false;
                                      this.$toaster.error(
                                        "Failed to update!!!"
                                      );
                                      console.log(
                                        "error in updateDetailsDataDistributions in lp details",
                                        error
                                      );
                                    });
                                })
                                .catch((error) => {
                                  self.showSpinner = false;
                                  this.$toaster.error("Failed to update!!!");
                                  console.log(
                                    "error in updateDistributionCallData in lp details",
                                    error
                                  );
                                });
                            })
                            .catch((error) => {
                              self.showSpinner = false;
                              this.$toaster.error("Failed to update!!!");
                              console.log(
                                "error in updating in lp details",
                                error
                              );
                            });
                        })
                        .catch((error) => {
                          self.showSpinner = false;
                          this.$toaster.error("Failed to update!!!");
                          console.log(
                            "error in updating in gp and carry",
                            error
                          );
                        });
                    })
                    .catch((error) => {
                      self.showSpinner = false;
                      this.$toaster.error("Failed to update!!!");
                      console.log("error in updating in thesis", error);
                    });
                })
                .catch((err) => {
                  self.showSpinner = false;
                  this.$toaster.error("Failed to update!!!");
                  console.log("error in updating in workspace", err);
                });
            })
            .catch((err) => {
              self.showSpinner = false;
              if (err.message && err.message.includes("exit"))
                this.$toaster.error(err.message);
              else {
                this.$toaster.error("Failed to update!!!");
                console.log("error in updating in fund", err);
              }
            });
        }
      }
    },
    handleCreateWorkspace() {
      let self = this;
      return new Promise((resolve, reject) => {
        let payload = {
          type: "Limited Partner",
          title: self.workspaceName,
          workspace_type: "Limited Partner",
          sectors: self.sectorValues,
          stages: self.stageValues,
          checkSizeMin:
            self.value.length >= 1 && self.value[0]
              ? self.roundNumber(self.value[0])
              : "",
          checkSizeMax:
            self.value.length >= 1 && self.value[1]
              ? self.roundNumber(self.value[1])
              : "",
        };
        self.$store
          .dispatch("workspace/apiPostworkspacesInst", payload)
          .then((user) => {
            if (user.success) {
              self.workspaceId = user.success.workspace;
              let payload = {
                account: user.success.account,
                workspace_id: user.success.workspace,
                workspace_title: self.workspaceName,
                workspace_type: "Limited Partner",
                sectors: self.sectorValues,
                stages: self.stageValues,
              };
              self.$store.dispatch("workspace/apiFetchworkspaces");
              self.$emit("switchWorkspace", payload);
              resolve();
            }
          })
          .catch((err) => {
            reject("Fail to create Workspace");
          });
      });
    },
    getThesisData() {
      const self = this;
      if (this.workspace && this.workspace.length > 0) {
        self.getFundAdditionalData();
        api
          .get(`/${this.workspace}/thesis`)
          .then((data) => {
            this.thesisRecords = data.data.encrypt.success;
            this.showSpinner = false;
            this.$store.commit(
              "lpAllocations/setThesisData",
              JSON.parse(JSON.stringify(this.thesisRecords))
            );
            if (this.thesisRecords.length == 0) {
              this.title = "Create Thesis";
            } else {
              this.showDocument = true;
              this.thesisData =
                this.thesisRecords && this.thesisRecords.length > 0
                  ? this.thesisRecords[0]
                  : {};
              let value = [];
              value[0] = this.thesisData.hasOwnProperty("checkSizeMin")
                ? this.thesisData.checkSizeMin
                : 0;
              value[1] = this.thesisData.hasOwnProperty("checkSizeMax")
                ? this.thesisData.checkSizeMax
                : 0;
              this.value = value;
              this.sectorValues = this.thesisData.hasOwnProperty("sectors")
                ? this.thesisData.sectors
                : [];
              this.stageValues = this.thesisData.hasOwnProperty("stages")
                ? this.thesisData.stages
                : [];
              let index = this.workspaces.findIndex((item) => {
                if (
                  item &&
                  item.hasOwnProperty("workspace") &&
                  item.workspace.hasOwnProperty("_id") &&
                  item.workspace._id == this.workspace
                ) {
                  return item;
                }
              });
              if (index >= 0) {
                this.workspaceName = this.workspaces[index].workspace.title;
              }
            }
          })
          .catch((error) => {
            console.log("error in fetching thesis data", error);
          });
      } else {
        this.title = "Create Thesis";
      }
    },
    editGpAndCarry() {
      const self = this;
      let serverData = self.$store.getters["lpAllocations/gpDetailsData"];
      let carryPercentage =
        this.thesisData.gpCarryProfit && Number(this.thesisData.gpCarryProfit)
          ? Number(this.thesisData.gpCarryProfit)
          : 20;
      let ownership =
        this.thesisData.gpOwnership && Number(this.thesisData.gpOwnership)
          ? Number(this.thesisData.gpOwnership)
          : 1;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (serverData && serverData.length > 0) {
          serverData.map((item) => {
            if (
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP Carry"
            ) {
              item.profit = Number(carryPercentage);
            }
            if (
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP"
            ) {
              item.ownership = Number(ownership);
              item.capital_commitment = Number(
                (
                  Number(item.ownership / 100) * Number(this.thesisData.size)
                ).toFixed(2)
              );
              item.profit = Number(
                (
                  1 -
                  Number(Number(carryPercentage) / 100) * Number(ownership)
                ).toFixed(2)
              );
              if (
                item.hasOwnProperty("capital_called") &&
                item.hasOwnProperty("open_balance")
              ) {
                item.remaining_commitment = Number(
                  (
                    Number(item.capital_commitment) -
                    Number(item.capital_called) +
                    Number(item.open_balance)
                  ).toFixed(2)
                );
              }
            }
            if (this.workspace && this.workspace.length > 0) {
              item.workspace = this.workspace;
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateGpDetails() {
      const self = this;
      let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let summaryData = self.$store.getters["lpAllocations/summaryData"];
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      let fundDetailsFundPercentage =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("ownership") &&
        Number(fundDetails[0].ownership)
          ? Number(fundDetails[0].ownership)
          : 0;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (detailsData && detailsData.length > 0) {
          let totalLpCommitment = 0;
          let gpCarry = 0;
          detailsData.map((item) => {
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "LP"
            ) {
              if (
                item.hasOwnProperty("capital_commitment") &&
                Number(item.capital_commitment) > 0
              ) {
                totalLpCommitment += Number(item.capital_commitment);
              }
            }
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP Carry"
            ) {
              if (item.hasOwnProperty("profit") && Number(item.profit) > 0) {
                gpCarry = Number(item.profit);
              }
            }
          });
          gpData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership) > 0
                ? Number(item.ownership)
                : 0;
            if (item.entity_type == "GP") {
              //gp% of lp capital commitment
              item.capital_commitment = Number(
                (
                  Number(Number(item.ownership) / 100) *
                  Number(totalLpCommitment)
                ).toFixed(2)
              );
              item.profit = Number(
                (
                  (Number(Number(fundDetailsFundPercentage) / 100) -
                    Number(Number(gpCarry) / 100)) *
                  Number(ownership)
                ).toFixed(2)
              );
              item.capital_called =
                item.capital_commitment &&
                summaryData &&
                summaryData.hasOwnProperty("capital_called_to_date") &&
                Number(summaryData.capital_called_to_date) > 0
                  ? Number(
                      (
                        Number(item.capital_commitment) *
                        (Number(summaryData.capital_called_to_date) / 100)
                      ).toFixed(2)
                    )
                  : 0;
              item.open_balance =
                item.hasOwnProperty("contributed_to_date") &&
                Number(item.contributed_to_date)
                  ? Number(
                      (
                        Number(item.capital_called) -
                        Number(item.contributed_to_date)
                      ).toFixed(2)
                    )
                  : 0;
              item.remaining_commitment = Number(
                (
                  Number(item.capital_commitment) -
                  Number(item.capital_called) +
                  Number(item.open_balance)
                ).toFixed(2)
              );
            }
            if (
              summaryData &&
              summaryData.hasOwnProperty("distributions") &&
              summaryData.hasOwnProperty("distributions_pre_carry") &&
              summaryData.hasOwnProperty("distributions_in_carry") &&
              Number(summaryData.distributions) > 0 &&
              Number(summaryData.distributions_pre_carry) &&
              Number(summaryData.distributions_in_carry)
            ) {
              if (
                summaryData.hasOwnProperty("distributed_to_date") &&
                summaryData.hasOwnProperty("capital_commitment") &&
                Number(summaryData.distributed_to_date) >
                  Number(summaryData.capital_commitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(summaryData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(summaryData.distributions_in_carry) *
                      (Number(item.profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  item.entity_type == "GP" &&
                  Number(summaryData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(summaryData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            }
            if (this.workspace && this.workspace.length > 0) {
              item.workspace = this.workspace;
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateLpOwnership() {
      const self = this;
      let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      let fundDetailsFundPercentage =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("ownership") &&
        Number(fundDetails[0].ownership)
          ? Number(fundDetails[0].ownership)
          : 0;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (lpData && lpData.length > 0) {
          let totalLpCommitment = 0;
          lpData.map((item) => {
            let capitalCommitment =
              item.hasOwnProperty("capital_commitment") &&
              Number(item.capital_commitment) > 0
                ? Number(item.capital_commitment)
                : 0;
            if (item.entity_type == "LP") {
              item.ownership = Number(
                (
                  (Number(capitalCommitment) /
                    Number(fundDetailsCapitalCommitment)) *
                  100
                ).toFixed(2)
              );
            }
            if (this.workspace && this.workspace.length > 0) {
              item.workspace = this.workspace;
            }
            payload.push(item);
            self.$store
              .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          resolve();
        }
      });
    },
    updateLpDetails() {
      const self = this;
      let payload = [];
      return new Promise((resolve, reject) => {
        self
          .updateGpDetails()
          .then((data) => {
            self
              .updateLpOwnership()
              .then((ownershipData) => {
                let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
                let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
                let detailsData =
                  self.$store.getters["lpAllocations/detailsData"];
                let summaryData =
                  self.$store.getters["lpAllocations/summaryData"];
                summaryData =
                  summaryData && summaryData.length > 0 ? summaryData[0] : {};
                let fundDetails =
                  self.$store.getters["lpAllocations/fundDetailsData"];
                let fundDetailsCapitalCommitment =
                  fundDetails &&
                  fundDetails.length > 0 &&
                  fundDetails[0] &&
                  fundDetails[0].hasOwnProperty("capital_commitment") &&
                  Number(fundDetails[0].capital_commitment)
                    ? Number(fundDetails[0].capital_commitment)
                    : 0;
                let fundDetailsFundPercentage =
                  fundDetails &&
                  fundDetails.length > 0 &&
                  fundDetails[0] &&
                  fundDetails[0].hasOwnProperty("ownership") &&
                  Number(fundDetails[0].ownership)
                    ? Number(fundDetails[0].ownership)
                    : 0;
                if (detailsData && detailsData.length > 0) {
                  let totalLpCommitment = 0;
                  let gpCarry = 0;
                  detailsData.map((item) => {
                    if (
                      item &&
                      item.hasOwnProperty("entity_type") &&
                      item.entity_type == "LP"
                    ) {
                      if (
                        item.hasOwnProperty("capital_commitment") &&
                        Number(item.capital_commitment) > 0
                      ) {
                        totalLpCommitment += Number(item.capital_commitment);
                      }
                    }
                    if (
                      item &&
                      item.hasOwnProperty("entity_type") &&
                      item.entity_type == "GP Carry"
                    ) {
                      if (
                        item.hasOwnProperty("profit") &&
                        Number(item.profit) > 0
                      ) {
                        gpCarry = Number(item.profit);
                      }
                    }
                  });
                  detailsData.map((item) => {
                    let capitalCommitment =
                      item.hasOwnProperty("capital_commitment") &&
                      Number(item.capital_commitment) > 0
                        ? Number(item.capital_commitment)
                        : 0;
                    let contributedToDate =
                      item.contributed_to_date &&
                      Number(item.contributed_to_date) > 0
                        ? Number(item.contributed_to_date)
                        : 0;
                    item.capital_called =
                      capitalCommitment &&
                      summaryData &&
                      summaryData.hasOwnProperty("capital_called_to_date") &&
                      Number(summaryData.capital_called_to_date) > 0
                        ? Number(
                            (
                              Number(capitalCommitment) *
                              (Number(summaryData.capital_called_to_date) / 100)
                            ).toFixed(2)
                          )
                        : 0;
                    let capitalCalled =
                      item.capital_called && Number(item.capital_called) > 0
                        ? Number(item.capital_called)
                        : 0;
                    if (item.entity_type == "LP") {
                      item.ownership = Number(
                        (
                          (Number(capitalCommitment) /
                            Number(fundDetailsCapitalCommitment)) *
                          100
                        ).toFixed(2)
                      );
                    }
                    let ownership =
                      item.hasOwnProperty("ownership") &&
                      Number(item.ownership) > 0
                        ? Number(item.ownership)
                        : 0;
                    item.lp_percentage =
                      item.entity_type == "LP"
                        ? Number(
                            (
                              (Number(capitalCommitment) /
                                Number(totalLpCommitment)) *
                              100
                            ).toFixed(2)
                          )
                        : 0;
                    item.open_balance = Number(
                      (
                        Number(capitalCalled) - Number(contributedToDate)
                      ).toFixed(2)
                    );
                    item.remaining_commitment = Number(
                      (
                        Number(capitalCommitment) -
                        Number(capitalCalled) +
                        Number(item.open_balance)
                      ).toFixed(2)
                    );
                    if (item.entity_type == "LP" || item.entity_type == "GP") {
                      item.profit = Number(
                        (
                          (Number(Number(fundDetailsFundPercentage) / 100) -
                            Number(Number(gpCarry) / 100)) *
                          Number(ownership)
                        ).toFixed(2)
                      );
                    }
                    if (
                      summaryData &&
                      summaryData.hasOwnProperty("distributions") &&
                      summaryData.hasOwnProperty("distributions_pre_carry") &&
                      summaryData.hasOwnProperty("distributions_in_carry") &&
                      Number(summaryData.distributions) > 0 &&
                      Number(summaryData.distributions_pre_carry) &&
                      Number(summaryData.distributions_in_carry)
                    ) {
                      if (
                        summaryData.hasOwnProperty("distributed_to_date") &&
                        summaryData.hasOwnProperty("capital_commitment") &&
                        Number(summaryData.distributed_to_date) >
                          Number(summaryData.capital_commitment)
                      ) {
                        //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                        item.distributions = Number(
                          (
                            Number(summaryData.distributions_pre_carry) *
                              (Number(ownership) / 100) +
                            Number(summaryData.distributions_in_carry) *
                              (Number(item.profit) / 100)
                          ).toFixed(2)
                        );
                      } else {
                        //distrubutions=distributed to date of summary*ownership%
                        item.distributions =
                          (item.entity_type == "LP" ||
                            item.entity_type == "GP") &&
                          Number(summaryData.distributed_to_date) > 0 &&
                          Number(ownership) > 0
                            ? Number(
                                (
                                  Number(summaryData.distributed_to_date) *
                                  Number(Number(ownership) / 100)
                                ).toFixed(2)
                              )
                            : 0;
                      }
                    }
                    if (this.workspace && this.workspace.length > 0) {
                      item.workspace = this.workspace;
                    }
                    payload.push(item);
                  });
                  self.$store
                    .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
                    .then((data) => {
                      resolve(data);
                    })
                    .catch((error) => {
                      reject(error);
                    });
                } else {
                  resolve();
                }
              })
              .catch((error) => {
                this.$toaster.error("Fail to update");
                console.log(
                  "error in updating lp ownership details inside update lp details",
                  error
                );
              });
          })
          .catch((error) => {
            this.$toaster.error("Fail to update");
            console.log(
              "error in updating gp details inside update lp details",
              error
            );
          });
      });
    },
    updateCurrentCapitalCallData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let lpDetailsData = self.$store.getters["lpAllocations/lpDetailsData"];
      return new Promise((resolve, reject) => {
        if (
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("_id")
        ) {
          let totalLpCapitalCalled = 0;
          let totalLpDistributions = 0;
          let totalFundCapitalCalled =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_called") &&
            Number(fundDetailsData[0].capital_called) > 0
              ? Number(fundDetailsData[0].capital_called)
              : 0;
          let totalFundDistributions =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("distributions") &&
            Number(fundDetailsData[0].distributions) > 0
              ? Number(fundDetailsData[0].distributions)
              : 0;
          let serverData = JSON.parse(JSON.stringify(currentCapitalCallData));
          let previousValue =
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty(
              "capital_called_to_date_amount"
            )
              ? Number(currentCapitalCallData.capital_called_to_date_amount)
              : 0;
          let previouCapitalCalledAmountValue =
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty("capital_called_amount")
              ? Number(currentCapitalCallData.capital_called_amount)
              : 0;
          let presentValue = Number(
            (
              Number(previousValue) - Number(previouCapitalCalledAmountValue)
            ).toFixed(2)
          );
          if (lpDetailsData && lpDetailsData.length > 0) {
            lpDetailsData.map((item) => {
              if (
                item &&
                item.hasOwnProperty("capital_called") &&
                Number(item.capital_called) > 0
              ) {
                totalLpCapitalCalled += Number(item.capital_called);
              }
              if (
                item &&
                item.hasOwnProperty("distributions") &&
                Number(item.distributions) > 0
              ) {
                totalLpDistributions += Number(item.distributions);
              }
            });
          }
          serverData.capital_called_amount =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_commitment") &&
            Number(fundDetailsData[0].capital_commitment) > 0
              ? Number(
                  (
                    Number(serverData.capital_called / 100) *
                    Number(fundDetailsData[0].capital_commitment)
                  ).toFixed(2)
                )
              : 0;
          serverData.capital_called_to_date_amount = Number(
            (
              Number(presentValue) + Number(serverData.capital_called_amount)
            ).toFixed(2)
          );
          //   serverData.moic =
          //     Number(this.portfolioValue) > 0 && Number(this.portfolioCost) > 0
          //       ? Number(
          //           (
          //             Number(this.portfolioValue) / Number(this.portfolioCost)
          //           ).toFixed(2)
          //         )
          //       : 0;
          //   serverData.tvpi =
          //     Number(totalLpCapitalCalled) > 0
          //       ? Number(
          //           (
          //             Number(this.portfolioValue) / Number(totalLpCapitalCalled)
          //           ).toFixed(2)
          //         )
          //       : 0;
          //   serverData.net_dpi =
          //     Number(totalLpCapitalCalled) > 0
          //       ? Number(
          //           (
          //             Number(totalLpDistributions) / Number(totalLpCapitalCalled)
          //           ).toFixed(2)
          //         )
          //       : 0;
          //   serverData.gross_dpi =
          //     Number(totalFundCapitalCalled) > 0
          //       ? Number(
          //           (
          //             Number(totalFundDistributions) /
          //             Number(totalFundCapitalCalled)
          //           ).toFixed(2)
          //         )
          //       : 0;
          if (serverData.hasOwnProperty("_id")) {
            if (this.workspace && this.workspace.length > 0) {
              serverData.workspace = this.workspace;
            }
            self.$store
              .dispatch("lpAllocations/apiPatchCapitalCallData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    updateSummaryData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let summaryData = self.$store.getters["lpAllocations/summaryData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        let serverData =
          summaryData && summaryData.length > 0
            ? JSON.parse(JSON.stringify(summaryData[0]))
            : {};
        serverData.capital_called =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called") &&
          Number(currentCapitalCallData.capital_called) > 0
            ? Number(currentCapitalCallData.capital_called)
            : 0;
        serverData.capital_called_to_date =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_to_date") &&
          Number(currentCapitalCallData.capital_called_to_date) > 0
            ? Number(currentCapitalCallData.capital_called_to_date)
            : 0;
        serverData.capital_called_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_amount") &&
          Number(currentCapitalCallData.capital_called_amount) > 0
            ? Number(currentCapitalCallData.capital_called_amount)
            : 0;
        serverData.capital_called_to_date_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty(
            "capital_called_to_date_amount"
          ) &&
          Number(currentCapitalCallData.capital_called_to_date_amount) > 0
            ? Number(currentCapitalCallData.capital_called_to_date_amount)
            : 0;
        serverData.current_capital_call =
          currentCapitalCallData && currentCapitalCallData.hasOwnProperty("_id")
            ? currentCapitalCallData._id
            : "";
        serverData.moic =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("moic") &&
          Number(currentCapitalCallData.moic) > 0
            ? Number(currentCapitalCallData.moic)
            : 0;
        serverData.tvpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("tvpi") &&
          Number(currentCapitalCallData.tvpi) > 0
            ? Number(currentCapitalCallData.tvpi)
            : 0;
        serverData.net_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("net_dpi") &&
          Number(currentCapitalCallData.net_dpi) > 0
            ? Number(currentCapitalCallData.net_dpi)
            : 0;
        serverData.gross_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("gross_dpi") &&
          Number(currentCapitalCallData.gross_dpi) > 0
            ? Number(currentCapitalCallData.gross_dpi)
            : 0;
        serverData.capital_commitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment) > 0
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        serverData.distributions =
          currentDistributionData.hasOwnProperty("distributions") &&
          Number(currentDistributionData.distributions)
            ? Number(currentDistributionData.distributions)
            : 0;
        serverData.distributions_pre_carry =
          currentDistributionData.hasOwnProperty("distributions_pre_carry") &&
          Number(currentDistributionData.distributions_pre_carry)
            ? Number(currentDistributionData.distributions_pre_carry)
            : 0;
        serverData.distributions_in_carry =
          currentDistributionData.hasOwnProperty("distributions_in_carry") &&
          Number(currentDistributionData.distributions_in_carry)
            ? Number(currentDistributionData.distributions_in_carry)
            : 0;
        serverData.distributed_to_date =
          currentDistributionData.hasOwnProperty("distributed_to_date") &&
          Number(currentDistributionData.distributed_to_date)
            ? Number(currentDistributionData.distributed_to_date)
            : 0;
        serverData.current_distribution =
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
            ? currentDistributionData._id
            : "";
        if (this.workspace && this.workspace.length > 0) {
          serverData.workspace = this.workspace;
        }
        if (summaryData && summaryData.length > 0) {
          if (serverData && serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchSummaryData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          self.$store
            .dispatch("lpAllocations/apiPostSummaryData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    updateDistributionCallData() {
      const self = this;
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        if (
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
        ) {
          let serverData = JSON.parse(JSON.stringify(currentDistributionData));
          serverData.distributed_to_date = serverData.hasOwnProperty(
            "distributed_to_date"
          )
            ? Number(serverData.distributed_to_date)
            : 0;
          serverData.distributions_in_carry =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_commitment") &&
            Number(fundDetailsData[0].capital_commitment)
              ? Number(
                  (
                    Number(serverData.distributed_to_date) -
                    Number(fundDetailsData[0].capital_commitment)
                  ).toFixed(2)
                )
              : 0;
          serverData.distributions_pre_carry = Number(
            (
              Number(serverData.distributed_to_date) -
              Number(serverData.distributions_in_carry)
            ).toFixed(2)
          );
          if (this.workspace && this.workspace.length > 0) {
            serverData.workspace = this.workspace;
          }
          self.$store
            .dispatch("lpAllocations/apiPatchDistributionData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    handleCancel() {
      document.body.className = "pageMainScroll sidebar-mini";
      this.$router.go(-1);
    },
    updateDetailsDataDistributions() {
      const self = this;
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let payload = [];
      return new Promise((resolve, reject) => {
        let capitalCommitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment)
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        if (detailsData && detailsData.length > 0) {
          detailsData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership)
                ? Number(item.ownership)
                : 0;
            let profit =
              item.hasOwnProperty("profit") && Number(item.profit)
                ? Number(item.profit)
                : 0;
            if (
              currentDistributionData &&
              currentDistributionData.hasOwnProperty("distributions") &&
              currentDistributionData.hasOwnProperty(
                "distributions_pre_carry"
              ) &&
              currentDistributionData.hasOwnProperty(
                "distributions_in_carry"
              ) &&
              Number(currentDistributionData.distributions) > 0 &&
              Number(currentDistributionData.distributions_pre_carry) &&
              Number(currentDistributionData.distributions_in_carry)
            ) {
              if (
                currentDistributionData.hasOwnProperty("distributed_to_date") &&
                capitalCommitment &&
                Number(capitalCommitment) &&
                Number(currentDistributionData.distributed_to_date) >
                  Number(capitalCommitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(currentDistributionData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(currentDistributionData.distributions_in_carry) *
                      (Number(profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  (item.entity_type == "LP" || item.entity_type == "GP") &&
                  Number(currentDistributionData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(currentDistributionData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            }
            if (this.workspace && this.workspace.length > 0) {
              item.workspace = this.workspace;
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    handleEditWorkspace() {
      let self = this;
      return new Promise((resolve, reject) => {
        let payload = {
          _id: this.workspace,
          type: "Limited Partner",
          title: self.workspaceName,
          workspace_type: "Limited Partner",
          sectors: self.sectorValues,
          stages: self.stageValues,
          checkSizeMin:
            self.value.length >= 1 && self.value[0]
              ? self.roundNumber(self.value[0])
              : "",
          checkSizeMax:
            self.value.length >= 1 && self.value[1]
              ? self.roundNumber(self.value[1])
              : "",
        };
        this.$store
          .dispatch("workspace/apiPatchworkspacesInst", payload)
          .then((workspace) => {
            let workspacePayload = {
              account: self.$route.params.account_id,
              workspace_id: payload._id,
              workspace_title: payload.title,
              workspace_type: "Limited Partner",
              sectors: payload.sectors,
              stages: payload.stages,
            };
            self.$store.dispatch("workspace/apiFetchworkspaces");
            self.editSwitchWorkspace(workspacePayload);
            resolve(workspace);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    editSwitchWorkspace(item) {
      let fiifi = JSON.parse(localStorage.fiifi).user;
      if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
        if (item.workspace_id == fiifi.workspace_id) {
          var defaultPayload = {
            workspace_title: item.workspace_title,
            workspace_type: item.workspace_type,
            workspace_id: item.workspace_id,
            sectors: item.sectors,
            stages: item.stages,
            targetCapitalToDeployPercent: item.targetCapitalToDeployPercent,
            feeAndExpenseLoadAssumptionPercent:
              item.feeAndExpenseLoadAssumptionPercent,
          };
          this.$store.commit("workspace/setDefaultPipeline", {
            payload: defaultPayload,
          });
          this.$store.commit("user/workspace_id", {
            workspace_id: item.workspace_id,
          });
        }
      }
    },
    checkFund(item) {
      let companies = this.portfolioAll;
      let check;
      if (item.properties.permalink) {
        if (companies && companies.length > 0) {
          check = companies.filter(
            (company) =>
              item.properties.permalink &&
              company.permalink == item.properties.permalink
          );
        }
      } else {
        if (companies && companies.length > 0) {
          check = companies.filter(
            (company) =>
              item.properties.name && company.name == item.properties.name
          );
        }
        if (check && check.length > 0)
          item.properties.short_description = "Company already exists";
      }
      if (check && check.length > 0) item.duplicate = "found";
      return item.properties.name;
    },
    getWorkspacePortfolio() {
      let self = this;
      self.$store
        .dispatch("portfolio/_apiFetchPortfolioByWorkspace", {
          workspace_id: this.workspace
            ? this.workspace
            : this.$route.params.workspace,
        })
        .then((data) => {
          let fund = data.find(
            (item) =>
              item.user_investment_status &&
              item.user_investment_status.toLowerCase() == "fund"
          );
          if (fund) {
            self.investor_stage = fund.investor_stage
              ? fund.investor_stage
              : "";
            self.$refs.refFundName.inputValue =
              fund && fund.name ? fund.name : "";
            self.fundName = fund && fund.name ? fund.name : "";
            self.fund_data = JSON.parse(JSON.stringify(fund));
            self.existingFund = JSON.parse(JSON.stringify(fund));
          }
          self.portfolioAll = data;
        })
        .catch((err) => {
          console.log("Fail to fetch workspace companies", { err });
        });
    },
    onAfterFundSelection(selectedValue) {
      let self = this;
      self.selected = true;
      self.fundName = "";
      self.fund_data = {};
      if (
        selectedValue.properties.short_description ==
        "No results Found. Continue.."
      ) {
        self.isNewFund = true;
        self.fund_data.name = selectedValue.properties.name;
        self.thesisData.name = self.fund_data.name;
      } else {
        self.fund_data.name = selectedValue.properties.name;
        self.thesisData.name = self.fund_data.name;
        self.fund_data.geography = selectedValue.properties.city_name;
        self.fund_data.website = selectedValue.properties.homepage_url;
        self.fund_data.facebook = selectedValue.properties.facebook_url;
        self.fund_data.linkedin = selectedValue.properties.linkedin_url;
        self.fund_data.twitter = selectedValue.properties.twitter_url;
        self.fund_data.logo_url = selectedValue.properties.profile_image_url;
        self.fund_data.permalink = selectedValue.properties.permalink;
        self.fund_data.cb_data = selectedValue;
      }
      self.fundName = self.thesisData.name;

      self.validations();
    },
    getFundAdditionalData() {
      const self = this;
      if (this.workspace && this.workspace.length > 0) {
        api
          .get(`/${this.workspace}/fundKpi`)
          .then((data) => {
            let fundAdditionalData = data.data.encrypt.success;
            if (fundAdditionalData.length > 0) {
              self.fundAdditionalData = JSON.parse(
                JSON.stringify(fundAdditionalData[0])
              );
              self.oldfundAdditionalData = JSON.parse(
                JSON.stringify(fundAdditionalData[0])
              );
            }
          })
          .catch((error) => {
            console.log("error in fetching fund additional data", error);
          });
      } else {
        this.title = "Create Thesis";
      }
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
  },
  created() {
    this.type = "Range";
    this.mintype = "MinRange";
    this.step = 10000;
    this.tooltip = {
      placement: "Before",
      isVisible: true,
      format: "C2",
      showOn: "Hover",
    };
    this.ticks = {
      placement: "After",
      format: "C2",
      largeStep: 1000000,
      smallStep: 1000000,
      showSmallTicks: true,
    };
    this.min = 1000;
    this.max = 10000000;
    this.height = 8;
    this.dotWidth = "22";
    this.bgStyle = {
      backgroundColor: "#fff",
      boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)",
    };
    this.tooltipStyle = {
      backgroundColor: "#FFD939",
      borderColor: "#FFD939",
    };
    this.absorb = true;
    this.processStyle = {
      backgroundColor: "#FFD939",
    };
    this.marks = 10000;
    this.tooltipMerge = true;
    this.formatter = (value) =>
      `${this.formatCurrency(value, this.currency.ref, 0, true)}`;
  },
  mounted() {
    this.getThesisData();
    if (this.workspace && this.workspace.length > 0) {
      this.getWorkspacePortfolio();
      document.body.className = "sidebar-mini editLpWorkspace pageMainScroll";
      this.showAdditionalInfo = true;
    } else {
      this.validations();
      this.portfolioAll = [];
      document.body.className = "sidebar-mini createLpWorkspace pageMainScroll";
    }
  },
  watch: {
    fundName: _.debounce(function (addr) {
      if (addr.length > 0) {
        this.getfunds(addr);
      }
      this.validations();
    }, 500),
  },
};
</script>
<style>
.createLpWorkspace .e-tooltip-wrap {
  z-index: 3 !important;
  top: 455px !important;
}

.createLpWorkspace .el-popper {
  top: 232px !important;
}

.editLpWorkspace .e-tooltip-wrap {
  z-index: 3 !important;
  top: 375px !important;
}

.editLpWorkspace .el-popper {
  top: 122px !important;
}
.lpAdditionalInfoCls {
  font-size: 14px;
  line-height: 16px;
  color: #060606;
  margin-top: 5px;
  margin-bottom: 15px;
}

.thesis-form-select .vs__dropdown-toggle {
  border: 0px solid !important;
}

.thesis-form-select .vs__dropdown-toggle .vs__actions {
  padding-top: 8px !important;
}

.thesis-form-select {
  padding: 0px;
}
</style>